import React from "react";
import { Button, Col } from "react-bootstrap";
import styles from "./inputField.module.css";
import Dropdown from "../../component/Dropdown/dropdown";

const InputField = ({
  label,
  conversionValueButton,
  image = "",
  disabled,
  value,
  onChange,
  errorMessage = "",
  forwardedRef,
  dropdown = "false",
  setCurrency,
  dropdownType = "",
  currencyOption,
  showJapan = true,
}) => {
  const handleChangeOption = (value) => {
    setCurrency(value);
  };

  return (
    <>
      <span className={styles.inputLabel}>{label}</span>
      <div
        className={styles.inputfieldDiv}
        style={dropdown === true ? { display: "flex" } : {}}
      >
        {dropdown === true && dropdownType === "HomeScreen" ? (
          <div className={styles.inputButton2}>
            <Dropdown
              label=""
              heading=""
              onChange={handleChangeOption}
              styling={"homepage"}
              showJapan={showJapan}
            />
          </div>
        ) : dropdown === true && dropdownType === "QuoteScreen" ? (
          <div className={styles.inputButton2}>
            <Dropdown
              options={currencyOption}
              label=""
              heading=""
              onChange={handleChangeOption}
              styling={"quotepage"}
            />
          </div>
        ) : (
          <Button className={styles.inputButton}>
            <div className={styles.inputleftdiv}>
              {image !== "" && (
                <img src={image} alt="" className={styles.imagediv}></img>
              )}
              <div className={styles.currency}>{conversionValueButton}</div>
            </div>
          </Button>
        )}

        <input
          ref={forwardedRef}
          type={
            label === "Recipient gets" ||
            label === "Recipient Gets" ||
            label === "Enter Amount"
              ? "number"
              : "text"
          }
          className={styles.inputNumber}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === "." || e.key === "-") e.preventDefault();
          }}
        ></input>
      </div>
      {errorMessage !== "" && (
        <div className={styles.errorState}>{errorMessage}</div>
      )}
    </>
  );
};

export default InputField;
